import { Circle, GoogleMap, InfoWindow, MarkerF, useLoadScript } from '@react-google-maps/api';
import '@styles/components/Map.css';
import { useEffect, useRef, useState } from 'react';

const center = {
    lat: -3.745,
    lng: -38.523
};

// setMapRefParent is OPTIONAL
// onMapClick is OPTIONAL: (latitude, longitude) of the clicked point (e.g. to move a qontact point)
// defaultCenter / defaultZoom are OPTIONAL: view used when there is nothing to show yet
const Map = ({markers, radius, setMapRefParent, circles = [], onMapClick = undefined, defaultCenter = undefined, defaultZoom = 11}) => {

    const containerStyle = {
        width: '100%',
        height: '100%',
        borderRadius: radius ? radius : '0px',
      };

    const {isLoaded} = useLoadScript({
        googleMapsApiKey: 'AIzaSyDsDpU-4o2I-YQtQelXqxsRkQtXY8j71rU',
        mapId: ['384532efca8f6434'],
    })

    const [mapRef, setMapRef] = useState(null);
    const hasMounted = useRef(false);

    const [markersState, setMarkersState] = useState(markers);

    const [isOpenMap, setIsOpenMap] = useState({});
    const [isClickedMap, setIsClickedMap] = useState({});

    const handleMouseOver = (id) => {
        setIsOpenMap(prev => ({ ...prev, [id]: true }));
    };

    const handleMouseOut = (id) => {
        setIsOpenMap(prev => ({ ...prev, [id]: false }));
    };

    const handleClick = (location, id) => {
        mapRef.panTo(location);
        mapRef.setZoom(14); // Set this to whatever zoom level you want
        setIsClickedMap(prev => ({ ...prev, [id]: !isClickedMap[id] }));
    };

    const handleCloseClick = (id) => {
        setIsOpenMap(prev => ({ ...prev, [id]: false }));
        setIsClickedMap(prev => ({ ...prev, [id]: false }));
    };


    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }

        setMarkersState(markers);
    }, [markers])


    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }

        if (mapRef && Object.keys(markersState).length > 0) {
            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                var extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
                var extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
                bounds.extend(extendPoint1);
                bounds.extend(extendPoint2);
            }

            
            mapRef.fitBounds(bounds);
        }
    }, [markersState])



    if (!isLoaded) {
        return
    }

    const bounds = new window.google.maps.LatLngBounds();

    const markerIcons = {
        "COMPLETED": {
            url: require('@assets/PNGs/Map/GreenMarker.png'),
            scaledSize: new window.google.maps.Size(48, 48),
        },
        "PENDING": {
            url: require('@assets/PNGs/Map/RedMarker.png'),
            scaledSize: new window.google.maps.Size(48, 48),
        },
        "GREEN": {
            url: require('@assets/PNGs/Map/GreenMarker.png'),
            scaledSize: new window.google.maps.Size(48, 48),
        },
        "RED": {
            url: require('@assets/PNGs/Map/RedMarker.png'),
            scaledSize: new window.google.maps.Size(48, 48),
        },
        "DARK_GRAY": {
            url: require('@assets/PNGs/Map/GrayMarker.png'),
            scaledSize: new window.google.maps.Size(48, 48),
        },
        "default": {
            url: require('@assets/PNGs/Map/GrayMarker.png'),
            scaledSize: new window.google.maps.Size(48, 48),
        }
    }

    const renderMarkerIcon = ({status}) => {
        const icon = markerIcons[status] || markerIcons.default;
        return icon;
    }

    circles.forEach((circle) => {
        if (
            circle?.center?.latitude == null ||
            circle?.center?.longitude == null ||
            circle?.radiusInMeters == null
        ) {
            return;
        }

        const circleBounds = new window.google.maps.Circle({
            center: {
                lat: parseFloat(circle.center.latitude),
                lng: parseFloat(circle.center.longitude),
            },
            radius: circle.radiusInMeters,
        }).getBounds();

        if (circleBounds) {
            bounds.union(circleBounds);
        }
    });

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={0}
            options={{ 
                mapId: "384532efca8f6434", 
                streetViewControl: false, 
                fullscreenControl: true, 
                mapTypeControl: false,
                gestureHandling: 'greedy',
                draggableCursor: onMapClick ? 'crosshair' : undefined,
            }}
            onClick={onMapClick ? (event) => {
                if (event?.latLng) {
                    onMapClick(event.latLng.lat(), event.latLng.lng())
                }
            } : undefined}
            onLoad={map => {
                if (bounds.isEmpty() && defaultCenter) {
                    map.setCenter(defaultCenter)
                    map.setZoom(defaultZoom)
                } else {
                    map.fitBounds(bounds)
                }
                setMapRef(map)
                if (setMapRefParent) {
                    setMapRefParent(map)
                }
            }}
        >
            {markersState.map((marker) => {
                if (marker.latitude == null || marker.longitude == null) {
                    console.log('Marker without latitude or longitude: ', marker)
                    return <></>
                }
                const safeParseFloat = (value) => isNaN(parseFloat(value)) ? 0 : parseFloat(value);

                const location = new window.google.maps.LatLng(
                    safeParseFloat(marker.latitude),
                    safeParseFloat(marker.longitude)
                );
                bounds.extend(location);

                return (
                    <MarkerF
                    key={marker.id}
                    position={location}
                    icon={renderMarkerIcon({status: marker.status})}
                    onMouseOver={() => handleMouseOver(marker.id)}
                    onMouseOut={() => handleMouseOut(marker.id)}
                    onClick={() => handleClick(location, marker.id)}
                  >
                    {(isOpenMap[marker.id] || isClickedMap[marker.id]) && marker.latitude && marker.longitude &&
                      <InfoWindow onCloseClick={() => handleCloseClick(marker.id)}>
                        <div style={{ width: 'auto', height: 'auto', overflow: 'hidden', color: '#667085'}}>
                          {marker.title}
                        
                          {isClickedMap[marker.id] && marker.contents &&        
                            marker.contents()
                          }
                          <div style={{width: '100%', height: '5px'}}/>
                        </div>
                      </InfoWindow>
                    }
                  </MarkerF>
                )
            })}

            {circles.map((circle) => {
                if (
                    circle?.center?.latitude == null ||
                    circle?.center?.longitude == null ||
                    circle?.radiusInMeters == null
                ) {
                    return null;
                }

                return (
                    <Circle
                        key={circle.id}
                        center={{
                            lat: parseFloat(circle.center.latitude),
                            lng: parseFloat(circle.center.longitude),
                        }}
                        radius={circle.radiusInMeters}
                        options={{
                            strokeColor: circle.strokeColor ?? '#EC6C56',
                            strokeOpacity: circle.strokeOpacity ?? 1,
                            strokeWeight: circle.strokeWeight ?? 2,
                            fillColor: circle.fillColor ?? '#EC6C56',
                            fillOpacity: circle.fillOpacity ?? 0.12,
                        }}
                    />
                );
            })}
        </GoogleMap>
    )
}
export default Map
